import { Injectable } from "@angular/core";
import { BehaviorSubject, ReplaySubject, Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class EneUiService {
  public languageChange$ = new BehaviorSubject<string | null>("de-ch");
  public textChange$: BehaviorSubject<string | null>;
  public onPanelUpdate$ = new ReplaySubject<any>(undefined);
  public onPanelVerticalHeightChange$ = new Subject<number | null>();

  private staticTextContent: any = {
    "de-ch": {
      true: "Ja",
      false: "Nein"
    },
    "de-de": {
      true: "Ja",
      false: "Nein"
    },
    "fr-fr": {
      true: "Oui",
      false: "Non"
    },
    "en-us": {
      true: "True",
      false: "False"
    }
  };

  constructor() {
    this.textChange$ = new BehaviorSubject(this.staticTextContent["de-ch"]);
  }

  /**
   * Takes the width of the window and returns a number or string depending on the width
   * It is used to calculate grids values
   *
   * @param innerWidth width of the window. if not set it will read it automatically
   * @param returnNameInsteadOfNumber set true if you want to get "sm" instead of "123"
   */
  public responsiveCalculator(
    innerWidth: number,
    returnNameInsteadOfNumber: boolean = false
  ): string | number | undefined {
    if (!innerWidth) {
      innerWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

    switch (true) {
      case Boolean(innerWidth < 1024): {
        return returnNameInsteadOfNumber ? "sm" : 42;
      }
      case Boolean(innerWidth >= 1024 && innerWidth < 1440): {
        return returnNameInsteadOfNumber ? "md" : 48;
      }
      case Boolean(innerWidth >= 1440 && innerWidth < 1930): {
        return returnNameInsteadOfNumber ? "lg" : 64;
      }
      case Boolean(innerWidth >= 1930): {
        return returnNameInsteadOfNumber ? "xl" : 80;
      }
      default: {
        return;
      }
    }
  }

  public setLanguage(language: string): void {
    this.languageChange$.next(language);
    this.textChange$.next(this.staticTextContent[language]);
  }
}
